import { useMemo } from 'react';

import RuleCard, { IRuleCardProps } from '~/src/features/domru-bonus/components/RuleCard';
import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';
import { rules } from '~/src/features/domru-bonus/data';

import * as RS from './styled';

const breakpoints = [
    { width: 0, slidesToShow: 1 },
    { width: 768, slidesToShow: 2 },
    { width: 1024, slidesToShow: 3 },
];

interface Iprops {
    cashback: string,
}

const Rules = ({ cashback }: Iprops): JSX.Element => {
    const isAbnProgramTermsEnabled = useMemo(getIsAbnLoyaltyProgramEnabled, []);

    return (
        <RS.CustomCarousel
            visibleCardWidth={1023}
            responsive={breakpoints}
            showArrows={false}
            showDots={false}
            showTransparent={true}
            hideArrow={true}
        >
            {rules(cashback, isAbnProgramTermsEnabled).map((rule: IRuleCardProps, index: number) => {
                const { title, desc, link } = rule;
                return (
                    <RuleCard
                        key={index}
                        title={title}
                        desc={desc}
                        link={link}
                    />
                );
            })}
        </RS.CustomCarousel>
    );
};

export default Rules;
